import { Component, OnInit } from '@angular/core';
import { AppServiceManager } from "common/services/appServiceManager";
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from "primeng/api";
import globalVariable from "../../../globalVariable/globalVariable.json";
import { ICompany } from 'app/shared/Domains/company';
import { Configuration } from "config/config";
import { CookieService } from 'ngx-cookie';
import { LanguageService } from 'app/LanguageService/Language.Service';


@Component({
  selector: 'app-user-information',
  templateUrl: './user-information.component.html',
  styleUrls: ['./user-information.component.css']
})
export class UserInformationComponent implements OnInit {
  errorExempleNumber: string;
  companyImage: ICompany
  fullName: any;
  gymName : any
  emailAdress: string;
  company: string;
  branch: string;
  address: any;
  selectedBranch: any;
  message: string;
  isSuccess: boolean;
  isError: boolean;
  branchName: string;
  username : string;
  loading: boolean;
  isMessage: boolean;
  isSubmitted: boolean;
  branchDetail: any;
  phoneNumber: string = '';
  placeholderText: string = 'Mobile Number*';
  EmailplaceholderText: string = 'Email*';

  constructor(
    private LanguageService: LanguageService,
    public config: Configuration,
    private MessageService: MessageService,
    private appServiceManager: AppServiceManager,
    private route: ActivatedRoute,
    private router: Router,
    private cookieService: CookieService,
  ) { }
	setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("UserInformationComponent", label);
  }
  ngOnInit(): void {
    this.route.queryParamMap
      .subscribe(params => {
        console.log('company:', params.get('company'));
        console.log('branch:', params.get('branch'));
        this.company = params.get('company');
        this.branch = params.get('branch');
        this.getBranchById();
        var currentUser = JSON.parse(localStorage.getItem('currentUser'));
        if(currentUser){
          this.username = currentUser.email;
        }
        // this.branches = this.branches.filter(branch => branch._id == this.branch);
        // if (this.branches.length > 0) {
        //   this.selectedBranch = this.branches[0];
        //   // console.log( this.selectedBranch);
        // }
        // else {
        //   console.log("Sorry, Please contact your administrator.");
        // }
      });


    this.errorExempleNumber = globalVariable.exampledata.pakNumber;

  }
  getBranchById() {
    this.appServiceManager.get('branches/' + this.branch).subscribe(
      (res) => {
        if (res) {
          this.selectedBranch = res;
          this.branchDetail = res;
        } else {
          this.MessageService.clear();
          this.MessageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
        }
      },
      (error) => {
        this.MessageService.clear();
        this.MessageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      }
    );
  }

  setMobilePlaceholder(pattern: string) {
    this.placeholderText = pattern; // Change placeholder on focus
  }

  resetMobilePlaceholder() {
    this.placeholderText = 'Mobile Number*'; // Reset placeholder on blur
  }
  setEmailPlaceholder(pattern: string) {
    this.EmailplaceholderText = pattern; // Change placeholder on focus
  }

  resetEmailPlaceholder() {
    this.EmailplaceholderText = 'Email*'; // Reset placeholder on blur
  }

  errorMsgClose() {
    this.isMessage = false;
    this.isError = false;
    this.isSuccess = false;
  }
  submit(form: any) {
    if (form.valid) {

      let payload = form.value;
      payload['branch'] = this.branch;
      payload['company'] = this.company;
      payload['username'] = this.username;
      this.appServiceManager
        .post("loginLogs", payload)
        .subscribe(
          (res: any) => {
            if (res.status === true) {
              form.reset();
              this.isSuccess = true;
              this.isError = false;
              this.isMessage = true;
              this.cookieService.put('firstLogin', 'false');
              this.router.navigateByUrl("members");
            } else {
              this.message = "Sorry, Something went wrong.";
              this.isMessage = true;
              this.isSuccess = false;
              this.isError = true;
            }
          },
          (error: any) => {
            this.isMessage = true;
            this.message = "Sorry, Something went wrong.";
            this.loading = false;
            this.isSuccess = false;
            this.isError = true;
          });

    }
    else {
      //  // Form validation error handling
      Object.keys(form.controls).forEach(controlName => {
        const control = form.controls[controlName];
        control.markAsTouched(); // Mark the control as touched to display the validation error messages
      });
    }
  }


}